export const getDeletedAddedElements = (
  originalIds: string[],
  updatedIds: string[],
  teamId:string,
  targetProp:string): { deleted: any[], added: any[]} => {
    return {
      added: addedElements( 
        originalIds,
        updatedIds,
        teamId,
        targetProp),
      deleted: deletedElements(
        originalIds,
        updatedIds)
    }
  }


export const deletedElements = (
  originalIds: string[],
  updatedIds: string[]): any[] => {
  return originalIds
  .map((id: string) => {
    if(updatedIds.includes(id)) {
      return undefined;
    }
    return id;
  })
  .filter((id: string | undefined) => id)
}

export const addedElements = (
  originalIds: string[],
  updatedIds: string[],
  teamId:string,
  targetProp:string): any[] => {
  return updatedIds
  .map((id: string) => {
    if(originalIds.includes(id)) {
      return undefined;
    }
    return id;
  })
  .filter((id: string | undefined) => id)
  .map((id: string | undefined) => {
    return {
      [targetProp]: id,
      team_id: teamId
    }
  })
}
